import { render, staticRenderFns } from "./AppNoteEditor.vue?vue&type=template&id=c5b05ac2&scoped=true&"
import script from "./AppNoteEditor.vue?vue&type=script&lang=js&"
export * from "./AppNoteEditor.vue?vue&type=script&lang=js&"
import style0 from "./AppNoteEditor.vue?vue&type=style&index=0&id=c5b05ac2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5b05ac2",
  null
  
)

export default component.exports